import React, { useState } from 'react';
import { useAuthContext } from 'components/shared/Auth';

import { CommentOutlined, HeartFilled, HeartOutlined, MessageOutlined, PhoneOutlined, ShoppingOutlined } from '@ant-design/icons';
import Link from 'components/shared/elements/Link';
import css from '../../ant/css/cards.module.css';
import { Tooltip } from 'antd';

export default function CardFooter({ item }) {
  const { accessToken } = useAuthContext();
  const [likes, setLikes] = useState(item?.likesNum ?? 0);
  const [liked, setLiked] = useState(item?.isLiked ?? false);

  const contacts = (
    <div>
      <div>{item.authorName}</div>
      {item.contacts?.phone ?? item.offerUrl}
    </div>
  );

  const toggleLike = (id) => {
    if (!accessToken) return;

    fetch(`/api/listings/${id}/likes`, {
      method: 'POST',
    })
      .then((res) => res.json())
      .then((data) => {
        setLikes(data?.likesNum ?? likes);
        setLiked(data?.liked ?? !liked);
      })
      .catch(() => {
        // ignore and keep current UI state
      });
  };

  return (
    <>
      <div
        className={css.fButton}
      >
        <Link href={`/listings/${item.slug}`}>
          <MessageOutlined /> 0 / 0
        </Link>
      </div>
      <div
        className={css.fButton}
        onClick={() => {
          toggleLike(item.id);
        }}
        style={{ cursor: accessToken ? 'pointer' : 'default' }}
      >
        {liked ? <HeartFilled style={{ color: '#278dca' }} /> : <HeartOutlined />} {likes}
      </div>
      <div className={css.fButton}>
        <Link href={`/chat/users/${item.authorId}`}>
          <CommentOutlined /> 0
        </Link>
      </div>
      <div className={css.fButton}>
        <Tooltip placement='topLeft' trigger='click' title={contacts}>
          <PhoneOutlined />
        </Tooltip>
      </div>
      <div className={css.fButton}>
        {item.offerUrl && (
          <Link target='_blank' href={item.offerUrl}>
            <ShoppingOutlined />
          </Link>
        )}
        {!item.offerUrl && <ShoppingOutlined />}
      </div>
    </>
  );
}
